import React, { useState } from 'react';
// getToken を追加でインポートします
import { getToken } from '../utils/auth';

const API_URL = window.location.hostname === 'localhost'
  ? (process.env.REACT_APP_API_URL || "http://localhost:3173")
  : window.location.origin;

const ProfileCompletionModal = ({ user, onSuccess, isEnglishBeta = false }) => {
  const [company, setCompany] = useState('');
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const copy = isEnglishBeta ? {
    title: "One more step",
    description: "Please register your company name and phone number to start using SalesBreaker.",
    companyLabel: "Company name",
    companyPlaceholder: "Example Inc.",
    phoneLabel: "Phone number",
    phonePlaceholder: "+1 555 123 4567",
    saving: "Saving...",
    submit: "Complete setup",
    networkError: "A network error occurred.",
    errorPrefix: "Profile update failed: ",
  } : {
    title: "あと一歩で完了です！",
    description: "サービスをご利用いただくために、会社名と電話番号のご登録をお願いいたします。",
    companyLabel: "会社名",
    companyPlaceholder: "株式会社サンプル",
    phoneLabel: "電話番号",
    phonePlaceholder: "03-1234-5678",
    saving: "保存中...",
    submit: "登録を完了してはじめる",
    networkError: "通信エラーが発生しました。",
    errorPrefix: "",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const res = await fetch(`${API_URL}/api/users/complete-profile`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // ★ 修正箇所: localStorage.getItem('token') から getToken() に変更
          'Authorization': `Bearer ${getToken()}`
        },
        body: JSON.stringify({ company, phone })
      });
      const data = await res.json();
      if (data.success) {
        onSuccess(data.user); // 親コンポーネント(AppLayout)のstateを更新
      } else {
        setError(`${copy.errorPrefix}${data.error}`);
      }
    } catch (err) {
      setError(copy.networkError);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/80 backdrop-blur-sm p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 animate-fade-in-up">
        <h2 className="text-2xl font-bold text-slate-900 mb-2">{copy.title}</h2>
        <p className="text-slate-600 mb-6 text-sm">
          {copy.description}
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-bold text-slate-500 mb-1">{copy.companyLabel}</label>
            <input
              type="text"
              required
              value={company}
              onChange={(e) => setCompany(e.target.value)}
              className="w-full px-4 py-3 bg-slate-50 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none"
              placeholder={copy.companyPlaceholder}
            />
          </div>
          <div>
            <label className="block text-xs font-bold text-slate-500 mb-1">{copy.phoneLabel}</label>
            <input
              type="tel"
              required
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="w-full px-4 py-3 bg-slate-50 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none"
              placeholder={copy.phonePlaceholder}
            />
          </div>

          {error && <p className="text-red-500 text-xs">{error}</p>}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-indigo-600 text-white font-bold py-4 rounded-xl hover:bg-indigo-700 transition-all disabled:bg-slate-400"
          >
            {loading ? copy.saving : copy.submit}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ProfileCompletionModal;
